"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.traverseNode = traverseNode;
exports.traverseNodeMarks = traverseNodeMarks;
exports.traverseNodeContent = traverseNodeContent;
exports.traverseAllMarks = traverseAllMarks;
function traverseNode(node, fn) {
    _traverseNode(node, undefined, fn);
}
function _traverseNode(node, parent, fn) {
    const result = fn(node, parent);
    if (result !== false) {
        node.content?.forEach((p) => {
            _traverseNode(p, node, fn);
        });
    }
}
function traverseNodeMarks(node, f) {
    node.marks?.forEach((p) => {
        f(p);
    });
}
function traverseNodeContent(node, f) {
    node.content?.forEach((p) => {
        f(p);
    });
}
function traverseAllMarks(node, f) {
    traverseNode(node, (node) => {
        traverseNodeMarks(node, (mark) => {
            f(node, mark);
        });
        return true;
    });
}
//# sourceMappingURL=traverse.js.map